module.exports = __webpack_public_path__ + "img/VL_09_03.48218e87.png";